import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper } from 'roo-ui/components';
import { useSelector } from 'react-redux';
import { getIsAuthenticated } from 'store/user/userSelectors';
import CustomerDetailsStepWizard from './CustomerDetailsStepWizard';
import PersonalDetails from './Steps/PersonalDetails';
import QantasPoints from './Steps/QantasPoints';
import PaymentOptions from './Steps/PaymentOptions';
import ConfirmAndPay from './Steps/ConfirmAndPay';
import { getIsClassic } from 'store/quote/quoteSelectors';
import usePaymentAllocation from './hooks/usePaymentAllocation';

const CustomerDetails = ({ quote, ...rest }) => {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const isClassic = useSelector(getIsClassic);

  usePaymentAllocation();

  return (
    <Wrapper quote={quote} {...rest}>
      <CustomerDetailsStepWizard collapsed={isClassic && !isAuthenticated}>
        <PersonalDetails key="personal-details" mb={6} data-testid="personal-details-form" />
        {!isClassic && [
          <QantasPoints key="qantas-points" mb={6} data-testid="qantas-points-form" />,
          <PaymentOptions key="payment-options" mb={6} data-testid="payment-options-form" />,
        ]}
        <ConfirmAndPay key="confirm-and-pay" data-testid="confirm-and-pay-form" />
      </CustomerDetailsStepWizard>
    </Wrapper>
  );
};

CustomerDetails.propTypes = {
  quote: PropTypes.shape({
    offer: PropTypes.object,
  }).isRequired,
};

export default CustomerDetails;
